/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */
export const VALIDATE_PASSCODE = "VALIDATE_PASSCODE";
export const VALIDATE_CAMPAIGN_ID = "VALIDATE_CAMPAIGN_ID";
export const SET_CAMPAIGN_ID = "SET_CAMPAIGN_ID";
export const SET_PASSCODE = "SET_PASSCODE";
export const SET_CAMPAIGN_IS_VALID = "SET_CAMPAIGN_IS_VALID";
export const SET_PASSCODE_IS_VALID = "SET_PASSCODE_IS_VALID";
export const SET_PALETTE_ID = "SET_PALETTE_ID";
export const SET_EXPIRATION_DATE = "SET_EXPIRATION_DATE";
export const SET_CAMPAIGN_IS_EXPIRED = "SET_CAMPAIGN_IS_EXPIRED";
export const SET_COOKIE = "SET_COOKIE";
export const REMOVE_COOKIE = "REMOVE_COOKIE";
